import {
  attachInstallIdToUrl
} from "./chunk-NU7VJWUN.mjs";
import {
  getContextInstallId
} from "./chunk-25YRKMCN.mjs";
import {
  INSTALLATION_ID_KEY
} from "./chunk-ADSPBXJF.mjs";

// src/listeners/related-domains-link-listener/related-domains-link-listener.ts
var querySelector = (domain) => `a[href^="https"][href*="${domain}"]:not([href*="${INSTALLATION_ID_KEY}="])`;
function relatedDomainsLinkListener() {
  if (window.yvaDatastore && window.yvaDatastore.currentContextId && window.yvaDatastore?.config.relatedDomains) {
    const relatedDomains = window.yvaDatastore.config.relatedDomains;
    const installationId = getContextInstallId();
    if (!installationId || relatedDomains.length <= 0) {
      return () => {
      };
    }
    const query = relatedDomains.reduce((queryString, domain, index, array) => {
      if (domain) {
        queryString += querySelector(domain);
        if (index < array.length - 1) {
          queryString += ",";
        }
      }
      return queryString;
    }, "");
    const observer = new MutationObserver(() => {
      const anchorElements = document.querySelectorAll(query);
      if (!anchorElements || anchorElements.length <= 0) {
        return;
      }
      anchorElements.forEach((anchorElement) => {
        const href = anchorElement.getAttribute("href");
        if (href) {
          try {
            const url = new URL(href);
            if (!url.searchParams.get(INSTALLATION_ID_KEY) && relatedDomains.some((domain) => url.origin.includes(domain))) {
              anchorElement.setAttribute("href", attachInstallIdToUrl(url.toString()));
            }
          } catch (error) {
            if (window.yvaDatastore?.config.debug) {
              console.warn(`Error adding install id to ${href}`, error);
            }
          }
        }
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => observer.disconnect();
  }
  return () => {
  };
}

export {
  relatedDomainsLinkListener
};
